import * as Yup from "yup";
import { PatientDiagnosis } from "../../../../../../../services";
import { createMapper } from "../../../../../../../utils/utils";

export const STATUS_OPTIONS = [
  { value: true, label: "Active" },
  { value: false, label: "Inactive" },
];

export const TYPE_OPTIONS = [
  { value: "CHRONIC", label: "Chronic" },
  { value: "ACUTE", label: "Acute" },
];

export const TYPE_OPTION_MAPPER = createMapper(TYPE_OPTIONS);

export type Diagnoses = Omit<PatientDiagnosis, "medicalCode" | "patient"> & {
  medicalCode?: { uuid: string; code: string };
};

export const DIAGNOSES_INITIAL_VALUE: Diagnoses = {
  medicalCode: undefined,
  name: "",
  active: true,
};

export const DIAGNOSES_VALIDATION_SCHEMA = Yup.object().shape({
  medicalCode: Yup.object().required().label("Diagnosis Name"),
  active: Yup.string().required().label("Status"),
});
